<template> 

  <BaseModal 
    :showing="showing" 
    :handleClose="close"
  >
    <!-- HEADER -->
    <template #header>
      <h2 class="text-ppd-green-dark text-2xl font-bold text-teal-700">Guardar levantamiento</h2>
    </template>

    <!-- BODY -->
    <template #body>
      <form
        class="form-group w-full"
        id="projectModalForm"
        @submit.prevent
      >
        <!-- Campo: Título -->
        <BaseInputText
          label="Título"
          name="title"
          v-model="title"
          :required="true"
          :error="errors.title"
          errorMessage="Escriba un título"
        />

        <!-- Campo: Descripción -->
        <BaseTextarea
          label="Descripción"
          name="description"
          v-model="description"
          :required="true"
          :error="errors.description"
          errorMessage="Escriba una descripción."
        />

        <!-- Campo: Proyecto -->
        <BaseSelect
          label="Proyecto"
          name="project"
          optionValue="id"
          optionLabel="nombre"
          v-model="selectedProject"
          :options="arrayProjects"
          :required="true"
          :error="errors.project"
          errorMessage="Seleccione un proyecto"
        />

        <!-- Campo: Categoría -->
        <BaseSelect
          label="Categoría"
          name="category"
          optionValue="id"
          optionLabel="nombre"
          v-model="selectedCategory"
          @update:modelValue="selectedCategory"
          :options="arrayMainCategories"
          :required="true"
          :error="errors.category"
          errorMessage="Seleccione una categoría"
          
        />

        <!-- Campo: Tipo -->
        <BaseSelect
          label="Tipo"
          name="type"
          optionValue="id"
          optionLabel="nombre"
          v-model="selectedType"
          @update:modelValue="selectedType"
          :options="arrayTypes" 
          :required="true"
          :error="errors.type"
          errorMessage="Seleccione un tipo"
          
        />

        <!-- Campo: Subcategoría -->
        <BaseSelect
          label="Subcategoría"
          name="subCategory"
          optionValue="id"
          optionLabel="nombre"
          v-model="selectedSubCategory"
          @update:modelValue="selectedSubCategory"
          :options="arraySubCategories"
          :required="true"
          :error="errors.subCategory"
          errorMessage="Seleccione una subcategoría"
          
        />

        <!-- Campo: Visibilidad -->
        <BaseSelect
          label="Visibilidad"
          name="visibility"
          v-model="selectedVisibility"
          @update:modelValue="selectedVisibility"
          :options="arrayVisibility"
          optionLabel="text"
          optionValue="value"
          :required="true"
          :error="errors.visibility"
          errorMessage="Seleccione un tipo de visibilidad"
          
        />
      </form>
    </template>

    <!-- FOOTER -->
    <template #footer>
      <BaseButton @click="save" icon="check">Guardar</BaseButton>
      <BaseButton variant="danger" class="ml-2" @click="close" icon="times">Cancelar</BaseButton>
    </template>
  </BaseModal> 
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import BaseButton from "./atoms/BaseButton.vue";
import BaseInputText from "./atoms/BaseInputText.vue";
import BaseSelect from "./atoms/BaseSelect.vue";
import BaseTextarea from "./atoms/BaseTextarea.vue"; 
import BaseModal from "./atoms/BaseModal.vue";

export default {
  name: "project-modal",
  data() {
    return {
      arrayProjects: [],
      arrayMainCategories: [],
      arrayTypes: [],
      arraySubCategories: [],
      arrayVisibility: [
        { value: false, text: 'Público' },
        { value: true, text: 'Privado' }
      ],
      selectedCategory: "",
      selectedType: "",
      selectedSubCategory: "",
      selectedProject: "",
      selectedVisibility: "",
      title: "",     
      description: "",
      
      isLoading: false,
      fullPage: true,   
 

      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      errors: {
        title: false,
        description: false,
        project: false,
        category: false,
        type: false,
        subCategory: false,
        visibility: false,
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    geometries: {
      required: true
    }
  },
  components: {
    Loading,
    BaseButton,
    BaseModal,
    BaseInputText,
    BaseTextarea,
    BaseSelect, 
  },  
  watch: {
    showing(value) {
      if (value) {
        this.fetchProjects();
        this.fetchMainCategories();
        this.fetchTypes();
        this.fetchSubCategories();
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }, 

    selectedCategory(value) {
      console.log("selectedCategory", value)
      this.updateSubCategories();
    },
    selectedType(value) {
      console.log("selectedType", value)
      this.updateSubCategories();
    },

  },
  methods: {
    reset() {
      this.title = "";
      this.description = "";
      
      this.subCategories = [];
      this.selectedCategory = "";
      this.selectedType = "";
      this.selectedSubCategory = "";
      this.selectedProject = "";
      this.selectedVisibility = "";
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    savedSuccesfully(){
      this.$emit("saved");
    },    
    save() {
      
      console.log("guardar!!");
      let fecha_registro = new Date().toLocaleString("es-MX", {timeZone: "America/Mexico_City"})

      const form = document.getElementById("projectModalForm");
      const formData = new FormData(form);
      const validForm = this.checkFormNewNotice(formData);
    
      if(this.geometries.length == 0) 
      { 
        this.$emit("trigger-alert", {
          type: "warning",
          title: "Advertencia",
          message: "No ha dibujado ninguna geometría",
        }); 
        //alert("No ha dibujado ninguna geometría")
        return;
      } else {
        // console.log(JSON.stringify(this.geometries));
        this.geometries.forEach(geometry => {

          if (!geometry.geometry) {
            geometry.geometry = {};
            geometry.properties = {};
            geometry.geometry.type = "";
            geometry.geometry.coordinates = geometry.coordinates
            geometry.geometry.type = geometry.type
            // geometry.properties.projectInfo = this.selectedProject;
            geometry.properties.projectInfo = {
              id: this.selectedProject.id,
              nombre: this.selectedProject.nombre
            };
            //geometry.properties.categoryInfo = this.selectedCategory;
            geometry.properties.categoryInfo = {
              id: this.selectedCategory.id,
              nombre: this.selectedCategory.nombre
            }
            //geometry.properties.typeInfo = this.selectedType;
            geometry.properties.typeInfo = {
              id: this.selectedType.id,
              nombre: this.selectedType.nombre            
            }

            //geometry.properties.subCategoryInfo = this.selectedSubCategory;
            geometry.properties.subCategoryInfo = {
              id: this.selectedSubCategory.id,
              nombre: this.selectedSubCategory.nombre              
            }

            geometry.properties.nombre = this.title
            geometry.properties.descripcion = this.description;
            geometry.properties.fecha = fecha_registro;          
            geometry.properties.metodo = "manual";
            geometry.properties.fuente = "web";
            geometry.properties.altitud = "N/A";
            geometry.type = "Feature"
            delete geometry.coordinates;
            // console.log("al final, así queda geometry");
            // console.log(geometry);
          } else {
            // geometry.properties.projectInfo = this.selectedProject;
            geometry.properties.projectInfo = {
              id: this.selectedProject.id,
              nombre: this.selectedProject.nombre
            };
            //geometry.properties.categoryInfo = this.selectedCategory;
            geometry.properties.categoryInfo = {
              id: this.selectedCategory.id,
              nombre: this.selectedCategory.nombre
            }
            //geometry.properties.typeInfo = this.selectedType;
            geometry.properties.typeInfo = {
              id: this.selectedType.id,
              nombre: this.selectedType.nombre            
            }

            //geometry.properties.subCategoryInfo = this.selectedSubCategory;
            geometry.properties.subCategoryInfo = {
              id: this.selectedSubCategory.id,
              nombre: this.selectedSubCategory.nombre              
            }

            geometry.properties.nombre = this.title
            geometry.properties.descripcion = this.description;
            geometry.properties.fecha = fecha_registro;          
            geometry.properties.metodo = "manual";
            geometry.properties.fuente = "web";
            geometry.properties.altitud = "N/A";
          }

          if(geometry.properties.typeGeometry && geometry.properties.typeGeometry == "Buffer") {
            delete geometry.properties.layerBufferID;
          }
        });

        

        // console.log(this.geometries);   

        let featureCollectionGeometries = {
          type: "FeatureCollection",
          features: this.geometries
        }

        // console.log(featureCollectionGeometries);
        if(validForm) {

          let data = {
            id_proyecto: this.selectedProject,
            id_cat_principal: this.selectedCategory,
            id_cat_secundaria: this.selectedSubCategory,
            id_tipo: this.selectedType,
            nombre: this.title,
            descripcion: this.description,
            fecha: fecha_registro,
            usuario: localStorage.getItem("email"),
            user_id: localStorage.getItem("user_uuid"),
            source: "web",
            geosource: "manual",
            privado: this.selectedVisibility.value,
            geometries: featureCollectionGeometries,
            altitude: "N/A"
            //geometries: this.geometries
          }
          this.axios
            .post(
              backend_url + "/api/ppd/levantamiento/newLevantamiento",
              data,
              this.config
            )
            .then((response) => {
              console.log(response);
              console.log(response.data.status);
              if(response.data.status == 'ok'){
                console.log("Se han guardado los datos")
                this.savedSuccesfully();
                this.Loading=false;
                //alert("Se han guardado los datos");
                this.$emit("trigger-alert", { 
                  type: "success",
                  title: "¡Operación exitosa!",
                  message: "Los datos han sido guardados correctamente.",
                }); 
              }
            })
            .catch((error) => {
              //console.log(error);
              this.showingError = true;
              this.Loading=false;
              //alert("Ha ocurrido un error");
              this.$emit("trigger-alert", { 
                type: "error",
                title: "¡Ocurrió un error!",
                message: error || "No se pudo completar la operación. Inténtalo de nuevo más tarde.",
              });
            }        
            );
          this.close(true);           
        } else {
          console.log("Formulario no válido")
        }
      }  
      
    },

    checkFormNewNotice: function (dataForm) {
      if (dataForm.get("title").trim() === "") {
        this.errors.title = true;

      } else {
        this.errors.title = false;
      }

      console.log(dataForm.get("description"));
      if (dataForm.get("description").trim() === "") {
        this.errors.description = true;
      } else {
        this.errors.description = false;
      }

      console.log(dataForm.get("project"));
      if (dataForm.get("project") === "" || dataForm.get("project") === null) {
        this.errors.project = true;
      } else {
        this.errors.project = false;
      }

      if (dataForm.get("category") === "" || dataForm.get("category") === null) {
        this.errors.category = true;
      } else {
        this.errors.category = false;
      }

      if (dataForm.get("type") === "" || dataForm.get("type") === null) {
        this.errors.type = true;
      } else {
        this.errors.type = false;
      }

      if (dataForm.get("subCategory") === "" || dataForm.get("subCategory") === null) {
        this.errors.subCategory = true;
      } else {
        this.errors.subCategory = false;
      }

      if (dataForm.get("visibility") === "" || dataForm.get("visibility") === null) {
        this.errors.visibility = true;
      } else {
        this.errors.visibility = false;
      }

      if (
        this.errors.title ||
        this.errors.description ||
        this.errors.project ||
        this.errors.category ||
        this.errors.type ||
        this.errors.subCategory ||
        this.errors.visibility
      ) {
        return false;
      }

      return true;
    },
    convertGeoJSON_WKT(polygon) {
      var wkt_str =
        "POLYGON(" +
        polygon.coordinates
          .map(function (ring) {
            return (
              "(" +
              ring
                .map(function (p) {
                  return p[0] + " " + p[1];
                })
                .join(", ") +
              ")"
            );
          })
          .join(", ") +
        ")";
      return wkt_str;
    },
    fetchProjects() {
      this.axios
        .get(backend_url + "/api/ppd/proyectos/getProjects", this.config)
        .then((response) => {
          //console.log(response.data.proyectos);
          this.arrayProjects = response.data.proyectos;
        });
    },
    fetchMainCategories() {
      this.axios
        .get(backend_url + "/api/ppd/catprinc/getMainCategories", this.config)
        .then((response) => {
          //console.log(response.data.categorias);
          this.arrayMainCategories = response.data.categorias;
        });
    },
    fetchTypes() {
      this.axios
        .get(backend_url + "/api/ppd/tipolevantamiento/getTypes", this.config)
        .then((response) => {
          //console.log(response.data.tipos);
          this.arrayTypes = response.data.tipos;
        });
    },
    fetchSubCategories(id_category, id_type) {
      this.selectedSubCategory = ""
      let data = {
        id_maincategory: id_category,
        id_type: id_type
      }
      this.axios
        .post(
          backend_url + "/api/ppd/subcategorias/getSubcategories",
          data,
          this.config
        )
        .then((response) => {
          //console.log(response.data.subcategorias);
          this.arraySubCategories = response.data.subcategorias;
        });
    },

    updateSubCategories() {
      console.log("updateSubCategories", this.selectedCategory, this.selectedType)
      if (this.selectedCategory != "" && this.selectedType != "") {
        this.fetchSubCategories(this.selectedCategory, this.selectedType);
      }  
    },
  },
  mounted() {},
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>
